import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import useGetAssessmentDetails from 'hooks/useGetAssessmentDetails';
import OverviewAssessmentBranding from 'pages/Overview/OverviewAssessmentBranding';
import OverviewAssessmentDetailsForm from 'pages/Overview/OverviewAssessmentDetailsForm';
import OverviewAssessmentHero from 'pages/Overview/OverviewAssessmentHero';
import { AssessmentDetailsContext } from 'providers/AssessmentDetailsProvider';
import { formatDateToEnUs } from 'utils/formatDate';

const Overview = () => {
  const { interviewUid } = useParams();
  const {
    data: interview,
    isLoading,
    isFetching,
  } = useGetAssessmentDetails(interviewUid ?? '');
  const { isPractice } = useContext(AssessmentDetailsContext);

  const {
    cohort_vision: cohortVision = '',
    company_cover_image: coverImage = '',
    company_dark_background_logo: darkBackgroundLogo = '',
    company_light_background_logo: lightBackgroundLogo = '',
    created_at: createdAt = '',
    name = '',
    number_of_invited_applicants: numberOfInvitedApplicants = 0,
    updated_at: updatedAt = '',
    uid = '',
    is_default_branding: isDefaultBranding = false,
  } = interview || {};

  const createdAtFormatted = formatDateToEnUs(createdAt);
  const updatedAtFormatted = formatDateToEnUs(updatedAt);

  return (
    <div className="container mx-auto w-full px-4">
      <div className="mb-2 mt-6">
        <OverviewAssessmentHero
          isLoading={isLoading || isFetching}
          numberOfApplicants={numberOfInvitedApplicants || 0}
          assessmentName={name}
          createdAt={createdAtFormatted}
          updatedAt={updatedAtFormatted}
          companyCoverImage={coverImage}
          companyCoverLogo={darkBackgroundLogo}
          isPractice={isPractice}
        />
      </div>
      <OverviewAssessmentDetailsForm
        assessmentName={name}
        cohortVision={cohortVision}
        interviewUid={uid}
        isLoading={isLoading || isFetching}
        isPractice={isPractice}
      />
      {!isPractice && (
        <OverviewAssessmentBranding
          isLoading={isLoading || isFetching}
          coverImage={coverImage}
          coverLogo={darkBackgroundLogo}
          emailLogo={lightBackgroundLogo}
          interviewUid={uid}
          isDefaultBranding={isDefaultBranding}
          assessmentName={name}
        />
      )}
    </div>
  );
};

export default Overview;
